/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import { MdSignalWifiConnectedNoInternet0 } from 'react-icons/md'

import AssetTableCell from './AssetTableCell'
import { formatDate12, getLocationColMeta, joinStrings, timeSinceFormatted } from './utils'

type LocationColProps = {
  value: string
  locationSampleTime: Date
  gatewayOn: boolean
}

const LocationCol: React.FC<LocationColProps> = ({ value, locationSampleTime, gatewayOn }) => {
  const { isValueBlank, displayBlank, displayMissing } = getLocationColMeta(gatewayOn, locationSampleTime, value)
  const lastValue = isValueBlank ? '<No reading>' : value

  const lastReportedString = locationSampleTime
    ? `Last value reported at ${formatDate12(locationSampleTime)} ${timeSinceFormatted(locationSampleTime)}`
    : ''
  const lastValueString = `Last value: ${lastValue}`
  let tooltip = lastReportedString
  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (displayBlank) {
    tooltip = joinStrings(lastReportedString, lastValueString)
  } else if (displayMissing) {
    tooltip = joinStrings('No data available', lastReportedString, lastValueString)
    displayValue = <MdSignalWifiConnectedNoInternet0 className="w-4 h-4 text-gray-500" />
  } else {
    displayValue = value
  }

  return <AssetTableCell tooltip={tooltip}>{displayValue}</AssetTableCell>
}

export default LocationCol
